import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import Box from "@mui/material/Box";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import AddTrip from "./AddTrip";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import AlertBar from "../../components/AlertBar";
import ModalPage from "../../components/ModalPage";
import {Divider, Grid} from "@mui/material";
import DateField from "../../components/DateField";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import {DriveEtaOutlined, UpdateOutlined} from "@mui/icons-material";
import ListItemText from "@mui/material/ListItemText";
import TableData from "../../components/TableData";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

export default function Trip(props) {
    const alert = useRef();
    const modal = useRef();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [trucks, setTrucks] = useState([]);
    const [data, setData] = useState({total: 0, data: []});
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [showProgress, setShowProgress] = useState(false);

    useEffect(() => {
        loadData();
        loadTrucks();
    }, [startDate, endDate]);

    const loadTrucks = () => {
        let url = `${BASE_URL}api/settings/available-truck`;
        window.axios
            .get(url)
            .then((response) => {
                setTrucks(response.data.data);
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };
    const loadData = () => {
        let url = `${BASE_URL}api/booking`;
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const bookingModal = (data) => {
        let component = <AddTrip loadData={loadData} modal={modal} data={data}/>;
        modal.current.show('Booking', component, '30%');
    }

    const ConfirmationModal = (items) => {
        let status = "active";
        let message = "";
        if (items?.status === "pending") {
            message = "Are you sure, you want to activate route?";
        } else if (items?.status === "active") {
            message = "Are you sure, you want to end route?";
            status = "complete";
        }
        let component = (<ConfirmationDialog
            message={message}
            handleClose={() => modal.current.hide()}
            handleOk={() => {
                modal.current.hide();
                submit(items, status)
            }}
        />);
        modal.current.show('Confirmation', component, '40%');
    }

    const submit = (item, status) => {
        let data = {
            status: status
        };
        alert.current.showProgress();
        window.axios
            .put(`${BASE_URL}api/booking/${item?.truckStatusControlId}`, data)
            .then(response => {
                alert.current.showSuccess("Update Successfully.");
                setTimeout(() => {
                    modal.current.hide();
                    loadData();
                }, 1000)
            })
            .catch(error => {
                reportErrors(alert.current, error);
            });
    }

    return (
        <Box>
            <AlertBar ref={alert}/>
            <Grid container spacing={2}>
                <Grid item xs={12}><Typography variant="h5">Trips</Typography></Grid>
                <Grid item xs={12}><Divider/></Grid>
                <Grid item xs={2}>
                    <DateField
                        showTimeSelect={true}
                        placeholder="Start Date"
                        dateFormat={"yyyy-MM-dd HH:mm"}
                        clearable={true}
                        selected={startDate}
                        onChange={(value) => setStartDate(value)}
                    />
                </Grid>
                <Grid item xs={2}>
                    <DateField
                        showTimeSelect={true}
                        placeholder="End Date"
                        dateFormat={"yyyy-MM-dd HH:mm"}
                        clearable={true}
                        selected={endDate}
                        onChange={(value) => setEndDate(value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{maxHeight: "250px", overflow: 'auto', p: 1}}>
                        <Grid container spacing={1}>
                            {trucks.map((e, index) => (
                                <Grid item xs={2}>
                                    <ListItemButton sx={{minHeight: "50px", border: '1px solid green'}}
                                                    onClick={() => bookingModal(e)} size={"small"}>
                                        <ListItemIcon><DriveEtaOutlined/></ListItemIcon>
                                        <ListItemText primary={e.plateNumber}/>
                                    </ListItemButton>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12}><Divider/></Grid>
                <Grid item xs={12}>
                    <TableData
                        showProgres={showProgress}
                        url=""
                        title="Trip List"
                        columns={[
                            {id: 'startDate', label: 'Start Date',},
                            {id: 'endDate', label: 'End Date',},
                            {
                                id: 'truck',
                                label: 'Plate Number',
                                customerRender: true,
                                valueGetter: (item) => (<>{item.truck?.plateNumber}</>)
                            },
                            {id: 'truckModel', label: 'Number of Passenger'},
                            {
                                id: 'user',
                                label: 'Prepared By',
                                customerRender: true,
                                valueGetter: (item) => (<>{item.user?.fullName}</>)
                            },
                            {id: 'remarks', label: 'Remarks'},
                            {id: 'status', label: 'Status'},
                            {
                                id: 'action',
                                label: 'Action',
                                minWidth: "small",
                                disabled: true,
                                customerRender: true,
                                valueGetter: (item) => (
                                    <IconButton size="small"
                                                onClick={() => ConfirmationModal(item)}><UpdateOutlined/></IconButton>)
                            },
                        ]}
                        rows={data}
                        rowClick={true}
                        rowFunction={(item) => {
                        }}
                    />
                </Grid>
            </Grid>
            <ModalPage ref={modal}/>
        </Box>
    );
}
